import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ValueService } from 'src/app/services/value.service';
declare let $: any;
@Component({
  selector: 'app-map-section',
  templateUrl: './map-section.component.html',
  styleUrls: ['./map-section.component.css'],
})
export class MapSectionComponent implements OnInit {
  constructor(private getdata: ValueService, private http: HttpClient) {}

  /**
   * Initializes the component by setting up tooltips and fetching startup map data.
   */
  ngOnInit(): void {
    // Initialize tooltips for elements with the data-toggle attribute set to 'tooltip'
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });

    // Fetch and display the map data for 'Startup' district
    this.mapGetBtn('Startup');
  }
  districtValue: any = {};
  actMap;
  /**
   * Fetches district data from the JSON file and updates the districtValue and map background.
   * It also toggles the active map class on the selected district.
   *
   * @param value - The name of the district to get data for.
   */
  mapGetBtn(value) {
    // Fetch district data from the local JSON file
    this.http
      .get<any>('./assets/json/districutcount.json')
      .subscribe((data) => {
        // Iterate over each element in the response data
        data.forEach((element) => {
          // Check if the element name matches the provided value
          if (element.name === value) {
            // Update the districtValue with the matched element
            this.districtValue = element;

            // If a URL is available, set it as the background image of the map
            if (this.districtValue.url) {
              document.getElementById(
                'map_id'
              ).style.backgroundImage = `url(${this.districtValue.url})`;
            }

            // Remove the active class from the previously active map
            $(this.actMap).removeClass('actMap');
            // Update actMap with the current value and add the active class
            this.actMap = '#' + value;
            $(this.actMap).addClass('actMap');
          }
        });
      });
  }
  viewdistrict(districtname) {
    this.getdata.district(districtname);
  }
}
